import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FileCaptureService } from 'app/service/file-capture.service';
import { FileServiceService } from '../service/file-service.service';

@Component({
  standalone: false,
  selector: 'app-routing',
  templateUrl: './routing.component.html',
  styleUrls: ['./routing.component.css']
})
export class RoutingComponent implements OnInit {
  selectedRoutingOption = '';

  constructor(
    private router: Router,
    public service: FileServiceService,
    private fileService: FileCaptureService
  ) { }

  ngOnInit(): void {
    this.service.setPageVisited('routing');
    this.selectedRoutingOption = this.service.getCache('routingOption') || this.service.referenceFileDetails.routingOption || '';
  }

  get showMedicalRecords(): boolean {
    return this.service.getConfigBoolean('MedicalRecordsRoutingEnabled', true);
  }

  get showAppeals(): boolean {
    return this.service.getConfigBoolean('AppealsReconsiderationsRoutingEnabled', false);
  }

  get showOverpayment(): boolean {
    return this.service.getConfigBoolean('OverpaymentAcknowledgmentRoutingEnabled', false);
  }

  continue(): void {
    if (!this.selectedRoutingOption) {
      return;
    }

    this.service.referenceFileDetails.routingOption = this.selectedRoutingOption;
    this.service.setCacheForitems([{ id: 'routingOption', value: this.selectedRoutingOption }]);
    this.router.navigate(['file-upload']);
  }

  back(): void {
    this.router.navigate(['reference']);
  }

  startOver(): void {
    const sessionId = window.sessionStorage.getItem(this.fileService.SESSION_KEY) || '';
    const payorKey = Number(window.sessionStorage.getItem(this.fileService.PAYOR_KEY) || 0);
    const referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');

    this.fileService.releaseActiveReferenceLock(payorKey, referenceId, sessionId).subscribe();
    this.service.clearCache();
    this.fileService.fileArray = [];
    const securityCode = window.localStorage.getItem('securityCode');
    this.router.navigate(['/' + securityCode]);
  }
}
